'use client';

import { useTranslations } from 'next-intl';
import { StatusNotification } from '../../../StatusNotification/StatusNotification';

type SettingsLoadErrorProps = {
  namespace: string;
  onRetry: () => void;
};

function SettingsLoadError({ namespace, onRetry }: SettingsLoadErrorProps) {
  const t = useTranslations(namespace);

  return (
    <StatusNotification
      type="error"
      role="alert"
      description={t('load_error.message')}
      buttonText={t('load_error.retry')}
      buttonTestId="settings-load-error-retry"
      onClick={onRetry}
      data-testid="settings-load-error"
    />
  );
}

export { SettingsLoadError };
